
$(document).on("switch_user#index:loaded", function() {
  $("#switch_user_search input").keyup(function() 
    {
    $.get($("#switch_user_search").attr("action"), $("#switch_user_search").serialize(),  null, "script");
    return false;
  });

});

  


